import { memo, ReactNode } from 'react';
import { Radio as RACRadio, RadioProps as RACRadioProps } from 'react-aria-components';

import { merge } from '@/components';

export type RadioProps = RACRadioProps & {};

const IRadio = ({ className, children, ...rest }: RadioProps) => {
  // eslint-disable-next-line prettier/prettier
  const styles = [
    'flex',
    'flex-row',
    'items-start',
    'gap-sm',
    'group/radio'
  ];

  const checkedStyles = [
    'size-3',
    'rounded-full',
    'border-1',
    'border-gray-300',
    'bg-white',
    'mt-[0.2rem]',
    'group-data-[selected]/radio:border-4',
    'group-data-[selected]/radio:border-primary-500',
  ];

  return (
    <RACRadio className={merge(styles, className)} {...rest}>
      <div className={merge(checkedStyles)} />
      {children as ReactNode}
    </RACRadio>
  );
};

export const Radio = memo(IRadio) as typeof IRadio;
